import { errorMsg } from '../../constants/messages';

const ParametersFormData = [
  {
    title: 'Parameter Details',
    name: 'name',
    label: 'Parameter Name',
    fieldType: {
      name: 'text',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Parameter Name', enableSort: false, allowAddRecordClick: true },
    isTableHeader: true,
    isAccordian: true,
    default: '',
  },
  {
    name: 'description',
    label: 'Description',
    fieldType: {
      name: 'textarea',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Description' },
    isTableHeader: true,
    isAccordian: true,
    default: '',
  },
];

export { ParametersFormData };
